import config from 'app-self-support-order/config'

const crmThirdPartyShopApi = `${config.apiHost}/oem-crm_third_party_shop`

export default {
    getOrderList: {
        url: `${crmThirdPartyShopApi}/api/order`,
        type: 'GET',
    },
    getOrderDetails: {
        url: `${crmThirdPartyShopApi}/api/order/item/{order_no}`,
        type: 'GET',
    },
    unBind: {
        url: `${crmThirdPartyShopApi}/api/customer/bind/{external_userid}`,
        type: 'DELETE',
    },
}
